import React from 'react';
import { motion } from 'framer-motion';
const MyStoryPage = () => {
  return <div className="bg-white min-h-screen" data-id="element-300">
      <div className="container mx-auto px-4 py-16" data-id="element-301">
        <motion.h1 className="text-4xl font-bold text-gray-800 mb-8 text-center" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5
      }} data-id="element-302">
          My Story
        </motion.h1>
        {/* Hero Section */}
        <div className="flex flex-col md:flex-row items-center md:items-start gap-8 mb-16" data-id="element-303">
          <motion.div className="md:w-1/3" initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-304">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fh4PvSXUQS6aUgE3nDidGB/AaKsyVTU_%281%29.png" alt="Aakash Gupta" className="rounded-lg shadow-lg w-full max-w-sm mx-auto" data-id="element-305" />
          </motion.div>
          <motion.div className="md:w-2/3" initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-306">
            <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-307">
              From Engineering to Product Leadership
            </h2>
            <p className="text-lg text-gray-700 mb-4" data-id="element-308">
              My journey in technology began with a passion for building
              products that solve real problems. With a background in both
              Economics and Psychology from the University of Michigan, I've
              always been fascinated by the intersection of human behavior and
              technology.
            </p>
            <p className="text-lg text-gray-700 mb-4" data-id="element-309">
              After graduating, I joined ScoutForce as one of their first
              product managers, where I helped transform college athletic
              recruiting by building digital tools that connected coaches with
              athletes. This experience taught me the fundamentals of product
              development and the importance of understanding user needs.
            </p>
            <p className="text-lg text-gray-700" data-id="element-310">
              My entrepreneurial spirit led me to co-found Rap to Beats, where
              we pioneered social music creation on iOS and scaled to 300K
              monthly active users. The challenges of building a product from
              scratch, finding product-market fit, and scaling user acquisition
              were invaluable lessons that shaped my approach to product
              leadership.
            </p>
          </motion.div>
        </div>
        {/* Education Section */}
        <motion.div className="mb-16" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-311">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-312">
            Education
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-313">
            <div className="bg-white rounded-lg shadow-lg p-6 flex items-start gap-4" data-id="element-314">
              <img src="https://upload.wikimedia.org/wikipedia/commons/f/f8/Wharton_Logo.png" alt="The Wharton School" className="w-16 h-16 object-contain" data-id="element-315" />
              <div data-id="element-316">
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-317">
                  The Wharton School
                </h3>
                <p className="text-gray-700 mb-1" data-id="element-318">
                  Master of Business Administration - MBA
                </p>
                <p className="text-gray-700" data-id="element-319">
                  Double Major: (1) Business Analytics (2) Entrepreneurship and
                  Innovation
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-lg p-6 flex items-start gap-4" data-id="element-320">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Michigan_Wolverines_logo.svg/1200px-Michigan_Wolverines_logo.svg.png" alt="University of Michigan" className="w-16 h-16 object-contain" data-id="element-321" />
              <div data-id="element-322">
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-323">
                  University of Michigan
                </h3>
                <p className="text-gray-700 mb-1" data-id="element-324">BS</p>
                <p className="text-gray-700" data-id="element-325">
                  Double Major: (1) Economics (2) Psychology
                </p>
              </div>
            </div>
          </div>
        </motion.div>
        {/* Career Journey Section */}
        <motion.div className="mb-16" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} data-id="element-326">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-327">
            Career Journey
          </h2>
          <div className="relative border-l-2 border-[#0FB9B1] ml-4 md:ml-0 md:mx-auto md:max-w-3xl pl-8 pb-8" data-id="element-328">
            {/* Apollo */}
            <div className="mb-12 relative" data-id="element-329">
              <div className="absolute -left-[41px] w-20 h-20 rounded-full bg-white border-4 border-[#0FB9B1] flex items-center justify-center" data-id="element-330">
                <img src="https://logo.clearbit.com/apollo.io" alt="Apollo.io" className="w-12 h-12 rounded-full object-contain" data-id="element-331" />
              </div>
              <div className="bg-white rounded-lg shadow-md p-6" data-id="element-332">
                <h3 className="text-xl font-bold text-gray-800 mb-1" data-id="element-333">
                  VP of Product at Apollo.io
                </h3>
                <p className="text-gray-600 mb-3" data-id="element-334">2023 — Present</p>
                <p className="text-gray-700" data-id="element-335">
                  Leading product strategy and execution at Apollo.io, helping
                  drive more than 100% YoY PLG growth and reaching a $2.5B
                  valuation. Focused on building innovative solutions for sales
                  teams and organizations to connect with their ideal customers.
                </p>
              </div>
            </div>
            {/* Affirm */}
            <div className="mb-12 relative" data-id="element-336">
              <div className="absolute -left-[41px] w-20 h-20 rounded-full bg-white border-4 border-[#0FB9B1] flex items-center justify-center" data-id="element-337">
                <img src="https://logo.clearbit.com/affirm.com" alt="Affirm" className="w-12 h-12 rounded-full object-contain" data-id="element-338" />
              </div>
              <div className="bg-white rounded-lg shadow-md p-6" data-id="element-339">
                <h3 className="text-xl font-bold text-gray-800 mb-1" data-id="element-340">
                  Head of Growth Product at Affirm
                </h3>
                <p className="text-gray-600 mb-3" data-id="element-341">2021 — 2023</p>
                <p className="text-gray-700" data-id="element-342">
                  Led growth initiatives at Affirm, focusing on customer
                  acquisition, activation, and retention. Developed strategies
                  that significantly expanded Affirm's user base while
                  maintaining strong unit economics.
                </p>
              </div>
            </div>
            {/* Epic Games */}
            <div className="mb-12 relative" data-id="element-343">
              <div className="absolute -left-[41px] w-20 h-20 rounded-full bg-white border-4 border-[#0FB9B1] flex items-center justify-center" data-id="element-344">
                <img src="https://logo.clearbit.com/epicgames.com" alt="Epic Games" className="w-12 h-12 rounded-full object-contain" data-id="element-345" />
              </div>
              <div className="bg-white rounded-lg shadow-md p-6" data-id="element-346">
                <h3 className="text-xl font-bold text-gray-800 mb-1" data-id="element-347">
                  Lead PM at Epic Games
                </h3>
                <p className="text-gray-600 mb-3" data-id="element-348">2019 — 2021</p>
                <p className="text-gray-700" data-id="element-349">
                  Played a key role in the success of Fortnite Chapter 2,
                  driving engagement and monetization strategies that helped
                  Fortnite maintain its position as one of the world's most
                  popular games.
                </p>
              </div>
            </div>
            {/* ThredUp */}
            <div className="relative" data-id="element-350">
              <div className="absolute -left-[41px] w-20 h-20 rounded-full bg-white border-4 border-[#0FB9B1] flex items-center justify-center" data-id="element-351">
                <img src="https://logo.clearbit.com/thredup.com" alt="ThredUp" className="w-12 h-12 rounded-full object-contain" data-id="element-352" />
              </div>
              <div className="bg-white rounded-lg shadow-md p-6" data-id="element-353">
                <h3 className="text-xl font-bold text-gray-800 mb-1" data-id="element-354">
                  Director of Growth at ThredUp
                </h3>
                <p className="text-gray-600 mb-3" data-id="element-355">2014 — 2017</p>
                <p className="text-gray-700" data-id="element-356">
                  Led growth efforts that resulted in 10x customer acquisition,
                  helping fuel ThredUp's $81M Series D+E funding rounds.
                  Developed innovative pricing strategies and conversion
                  optimization techniques that significantly improved business
                  metrics.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
        {/* Personal Philosophy Section */}
        <motion.div className="bg-gray-50 rounded-lg p-8 mb-16" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} data-id="element-357">
          <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-358">
            My Product Philosophy
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-359">
            <div className="bg-white rounded-lg shadow-md p-6" data-id="element-360">
              <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-361">
                User-Centered Design
              </h3>
              <p className="text-gray-700" data-id="element-362">
                I believe that exceptional products start with a deep
                understanding of user needs. By empathizing with users and
                designing solutions that address their pain points, we create
                products that people love and recommend.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6" data-id="element-363">
              <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-364">
                Data-Driven Decisions
              </h3>
              <p className="text-gray-700" data-id="element-365">
                While intuition has its place, data should drive product
                decisions. I'm passionate about establishing clear metrics,
                running rigorous experiments, and letting results guide our
                strategy.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6" data-id="element-366">
              <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-367">
                Cross-Functional Collaboration
              </h3>
              <p className="text-gray-700" data-id="element-368">
                Great products are built by great teams. I thrive in
                environments where product, engineering, design, and business
                teams work closely together, sharing knowledge and aligning on
                goals.
              </p>
            </div>
          </div>
        </motion.div>
        {/* Call to Action */}
        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.7
      }} data-id="element-369">
          <h2 className="text-3xl font-bold text-gray-800 mb-6" data-id="element-370">
            Let's Connect
          </h2>
          <p className="text-xl text-gray-700 mb-8 max-w-3xl mx-auto" data-id="element-371">
            I'm always open to discussing product strategy, growth
            opportunities, or sharing insights from my experience across B2B and
            B2C products.
          </p>
          <motion.a href="mailto:productgrowthppp@gmail.com" className="px-8 py-4 bg-[#0FB9B1] text-white rounded-md font-medium text-lg hover:bg-[#0ca69e] transition-colors inline-block" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.97
        }} data-id="element-372">
            Get in Touch
          </motion.a>
        </motion.div>
      </div>
    </div>;
};
export default MyStoryPage;